import styled, { css } from 'styled-components';

type ListContainerAttributes = {
  type?: string;
};

export const ListContainer = styled.li(
  ({ type = 'none' }: ListContainerAttributes) => css`
    list-style-type: ${type};
    margin-bottom: 1em;
    margin-left: 1.5em;
    position: relative;
    display: list-item;
  `
);

export const ListIndex = styled.span`
  margin-right: 1em;
`;
